export default __webpack_public_path__ + "static/media/branch.60ae1925.png";